import { handleActions } from 'redux-actions';

import * as actions from 'actions/country';

const initialState = {
  loading: false,
  error: null,
  countries: [],
};

const country = handleActions(
  new Map([
    [
      actions.fetchCountriesActions.request,
      state => ({
        ...state,
        error: null,
        loading: true,
        countries: [],
      }),
    ],
    [
      actions.fetchCountriesActions.success,
      (state, action) => ({
        ...state,
        loading: false,
        error: null,
        countries: action.payload,
      }),
    ],
    [
      actions.fetchCountriesActions.error,
      (state, action) => ({
        ...state,
        loading: false,
        error: action.payload,
        countries: [],
      }),
    ],
  ]),
  initialState,
);

export default country;
